import React from 'react';
import * as S from './styles';

export interface ErrorMessageProps {
  children?: React.ReactNode;
  id?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, id }) => (
  <S.Root forwardedAs="p" id={id}>
    {children}
  </S.Root>
);

export default ErrorMessage;
